import React, {ReactNode, useEffect} from 'react';
import Page from '@episerver/spa-core/Page';
import CellcomCareersPageData from "../../../Models/Content/CellcomCareersPageData";
import CareersPage from './CareersPage'

export default class CellcomCareersData extends Page<CellcomCareersPageData> {
    public render(): ReactNode {
      return <CareersPage data={this.props.data} context={this.getContext()}  />
      }
}
